import * as React from 'react';
import ProjectLayout from '../ProjectLayout';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';
import SurveyHeader from '../survey/SurveyHeader';
import { css } from '@emotion/core';
import { COLORS } from '../../globalStyle/colors';
import { onMobileDevice } from '../../globalStyle/mediaQueries';
import { useAppState } from '../../core/redux/hooks';
import * as R from 'ramda';
import { useMount } from '../../core/hooks/useMount';
import { useDispatch } from 'react-redux';
import { getECourseUrlAction } from '../api/getECourseUrlAction';
import { getECoursePopupAction } from '../api/getECoursePopupAction';
import { useProjIds } from '../../navigation/hooks';
import { Loader } from '../../loading/Loader';
import { useError } from '../../core/api/hooks';
import { ActionType } from '../../core/redux/actionType';
import Msg from '../../localization/Msg';


const styles = {
  content:       css`
    margin-top: 62px;
    background-color: ${COLORS.WHITE};
    width: 100%;

    ${onMobileDevice} {
      margin-top: 20px;
    }
  `,
  header: css`
    ${onMobileDevice} {
      margin-top: 37px;
    }  
  `,
  loader:        css`
    width: 150px;
    height: 150px;
    margin: auto;
  `,
  iframe:        css`
    width: 100%;
    height: calc(100vh - 53px);
  `,  
  iframeHidden:  css`
    width: 0;
    height: 0;
  `,
  eCourseMessage: css`
    margin-top: 37px;
    display: block;
  `,
  
  link:           css`
    display: block;
    padding: 18px 15px;
    text-decoration: none;
    
    &:hover {
      cursor: pointer;
    }
  `,
};


type Props = {
  className?: string;
};


/**
 * ECourse: a component that displays an ECourse from VitalSource
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ECourse: React.FC<Props> = props => {
  const pageTitle = useMsgText(Str.ECourse);

  const dispatch = useDispatch();

  const projIds       = useProjIds();
  const participantId = projIds.participantId;
  const projectId     = projIds.projId;
  const url           = useAppState(state => state.eCourseUrl);
  const popup         = useAppState(state => state.eCoursePopup);

  const useUrl = React.useMemo(() => url, [url]);
  const usePopup = React.useMemo(() => popup, [popup]);

  const error  = useError(ActionType.GetECourseUrlRequest, `${projectId}`);

  useMount(() => {
    // always get new URL since they are only valid for 2 minutes
    dispatch(getECourseUrlAction(projectId, participantId));
    dispatch(getECoursePopupAction(projectId));
  });

  return (
    <ProjectLayout className={props.className}>
      <SurveyHeader title={`/ ${pageTitle}`} deadline={undefined} css={styles.header}/>

      {
        R.isNil(useUrl)
          ? !!error
            ? <Msg defaultMsg='X' str={Str.ECourseRegistrationFailed} css={styles.eCourseMessage} />
            : <Loader css={styles.loader} />
          : usePopup
            ? <>
                <Msg defaultMsg='X' str={Str.ECoursePopupMsg} css={styles.eCourseMessage} />
                <iframe
                  frameBorder={0}
                  css={styles.iframeHidden}
                  src={url}
                  title='e-course-hidden'
                />
              </>
            : <>
                <iframe
                  frameBorder={0}
                  css={styles.iframe}
                  src={url}
                  title='e-course'
                />
{/*
                <a
                  href={url}
                  css={styles.link}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  View course in new window (eventually replace with an iframe or auto open)
                </a>
*/}
              </>
      }
    </ProjectLayout>
  )

};

export default ECourse;
